import "../../styles/theme.scss";
import { functionalCookieConsentAllowedOnce } from '../services/consent.service';
import { waitForElements, getElementOrParentByClassName } from '../helpers/utils';
import { scrollTo } from '../helpers/scrollPage';
import { getCart, updateCart, cartState } from '../services/cart.service';
// modules
import DyEvents from '../modules/DyEvents';
import Accordion from '../modules/Accordion';
import Form from '../modules/Form';
import VideoModal from '../modules/VideoModal';
import InlineCart from '../modules/InlineCart';
import Nav from '../modules/Nav';
import Scroll from '../modules/Scroll';
import LazyImages from '../modules/LazyImages';
import CustomCheckbox from '../modules/CustomCheckbox';
import { attachSessionIdsToCart, csqTrackDynamicVariable, emitShopifyEvent, getCSQGlobal, dialogStack } from "../services/analytics.service";
import { initMediaContentListeners } from '../services/media-content.service';
import '../web-components/product-card';
import '../web-components/product-main';
import '../web-components/loading-spinner';
import '../web-components/cart-progress';
import '../web-components/cart-progress-tiers';
import '../web-components/cart-line-item';
import '../web-components/global-banner';
import '../web-components/main-nav-desktop';
import '../web-components/selected-store';
import '../web-components/search-form';
import '../web-components/save-for-later-list';
import '../web-components/carousel-selector';
import '../web-components/toggle-module';
import '../web-components/review-carousel';
import '../web-components/quickshop';
import '../web-components/color-swatch-list';
import '../web-components/hotspot-button';
import { initSelectedStore, selectedStoreState } from "../services/store.service";
import { initSaveForLater, initWishlistEventListeners } from "../services/wishlist.service";
getCart(); // initialize cart state
// Layout
class ThemeLayout {
    constructor() {
        console.log('UNTUCKit : Layout : Theme : loaded', this);
    }
    ready() {
        console.log('UNTUCKit : Layout : Theme : ready', this);
        Accordion.init();
        Form.init();
        CustomCheckbox.init();
        VideoModal.init();
        Nav.init();
        Scroll.init();
        // Global
        LazyImages.update();
        initMediaContentListeners();
        functionalCookieConsentAllowedOnce.subscribe(() => {
            DyEvents.init();
            attachSessionIdsToCart();
            initWishlistEventListeners();
            document.addEventListener('click', (e) => {
                const target = e.target;
                if (getElementOrParentByClassName(target, "js-marketing-opt-in")) {
                    e.preventDefault();
                    if (window.__attentive) {
                        if (window.innerWidth >= 760) {
                            window.__attentive.trigger(null, null, null, window.UNTUCKitConfig.thirdPartyToggles.attentiveManualPopupDesktopId);
                        }
                        else {
                            window.__attentive.trigger(null, null, null, window.UNTUCKitConfig.thirdPartyToggles.attentiveManualPopupMobileId);
                        }
                    }
                }
            });
            if (window.UNTUCKitConfig.nearbyToggle.enable) {
                initSelectedStore();
            }
            selectedStoreState.subscribe((store) => {
                if (store) {
                    const cart = cartState.get();
                    if (cart && store.COLLECTION_HANDLE && cart?.attributes?._selected_store_handle !== store.COLLECTION_HANDLE) {
                        updateCart({
                            attributes: {
                                _selected_store_handle: store.COLLECTION_HANDLE
                            }
                        });
                    }
                }
            });
            // handle nobi search dialog
            window.addEventListener('nobi-close-drawer', () => {
                dialogStack.pop('nobi-search');
            });
            window.addEventListener('nobi-chatbot-viewed', () => {
                dialogStack.push('nobi-search');
            });
        });
        const params = new URLSearchParams(window.location.search);
        if (params && params.get("highstreet")) {
            // attempt to keep app users within the "app view"
            const links = Array.from(document.querySelectorAll("a[href^='/'], a[href*='untuckit.']:not([href^='mailto'])"));
            links.forEach((l) => {
                if (l.href) {
                    l.href += `${(l.href.includes("?") ? "&" : "?")}highstreet=true&hlt=1`;
                }
            });
        }
    }
    load() {
        InlineCart.init();
        document.addEventListener("submit", handleCheckoutFormSubmit);
    }
}
const untuckitTheme = new ThemeLayout();
$(() => {
    untuckitTheme.ready();
});
$(window).on('DOMContentLoaded', () => {
    untuckitTheme.load();
});
/**
 * prevents back-forward caching, which can cause cached data to be displayed.
 * see: https://web.dev/bfcache/
 *
 */
window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
        window.location.reload();
    }
});
/**
 *
 * @param {SubmitEvent} e
 */
async function handleCheckoutFormSubmit(e) {
    const target = e.target;
    if (target.action?.includes('/checkout')) {
        const checkoutSpinnerEl = target.querySelector('.js-checkout-spinner');
        if (checkoutSpinnerEl) {
            checkoutSpinnerEl.classList.remove('hidden');
        }
        const checkoutTextEl = target.querySelector('.js-checkout-text');
        if (checkoutTextEl) {
            checkoutTextEl.textContent = window.UNTUCKitConfig.checkoutLoadingText;
        }
        // check if narvar shop now; otherwise allow form submission to continue (i.e. no e.preventDefault)
        if (typeof window.nv_shopnow?.hasSession === 'function'
            && window.nv_shopnow.hasSession()
            && typeof window.nv_shopnow.checkout === 'function') {
            try {
                e.preventDefault();
                const res = await window.nv_shopnow.checkout();
                location.replace(res.weburl);
            }
            catch (err) {
                console.error("narvar shop now error", err.message || err);
            }
        }
    }
}
const customerData = window.segmentLayer?.customer;
if (customerData) {
    emitShopifyEvent("utk_identify_customer", window.segmentLayer.customer);
    const isLoggedIn = !!(customerData?.id);
    csqTrackDynamicVariable('login_state', isLoggedIn ? 'logged_in' : 'guest');
    if (customerData.email) {
        getCSQGlobal().push(["trackPageEvent", `@user-identifier@${customerData.email}`]);
        csqTrackDynamicVariable('customer_type', (customerData.order_count ?? 0) > 1 ? 'returning' : 'new');
        csqTrackDynamicVariable('customer_order_count', customerData.order_count ?? 0);
        csqTrackDynamicVariable('customer_lifetime_value', Math.round(customerData.lifetime_value ?? 0));
    }
}
if (window.UNTUCKitConfig.thirdPartyToggles.swym && window.UNTUCKitConfig.thirdPartyToggles.swymSaveForLater) {
    initSaveForLater();
}
/**
 * workaround due to the url hash not anchoring for dynamically-generated content
 * ex: https://www.untuckit.com/collections/shirts?section=shopify-section-collection-template-boost-pfs-filter
 */
window.addEventListener('DOMContentLoaded', () => {
    const section = new URLSearchParams(location.search).get('section');
    if (section) {
        waitForElements(`#${section}`).then((els) => {
            scrollTo(els[0]);
        });
    }
});
